import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onCancel: () => void
  disabled: boolean
}

const Footer = ({ onCancel, disabled }: Props) => {
  const buttonText = i18n.t('common.save')

  return (
    <>
      <Button type="secondary" onClick={onCancel}>
        {i18n.t('common.cancel')}
      </Button>
      <Button disabled={disabled} submit>
        {buttonText}
      </Button>
    </>
  )
}

export default Footer
